import { t } from 'i18next';
import { Bar } from '../../shared/components/bar';
import { GraphicFrame } from '../../shared/components/graphic-frame';
import { PlantGraphic } from '../../shared/components/plant-graphic';

// Decorative cart graphic for the order step, mirroring the buyer's storefront cart with a couple of prefilled line items.
function PlantThumb() {
  return (
    <span className="grid size-7 shrink-0 place-items-center rounded-md bg-gray-100">
      <PlantGraphic
        mini
        className="h-4 w-auto"
        title={t('features:onboarding.components.cart_preview.product')}
      />
    </span>
  );
}

function CartLine({
  nameWidth,
  priceWidth,
  qty,
}: {
  nameWidth: string;
  priceWidth: string;
  qty: string;
}) {
  return (
    <div className="flex flex-1 items-center gap-2.5 border-gray-100 border-b px-3">
      <PlantThumb />
      <span className="min-w-0 flex-1">
        <Bar className="mb-1.25 h-1.5" style={{ width: nameWidth }} />
        <Bar tone="muted" className="h-1.5" style={{ width: priceWidth }} />
      </span>
      <span className="font-semibold text-[11px] text-gray-400">{qty}</span>
    </div>
  );
}

export function CartGraphic() {
  return (
    <GraphicFrame>
      {/* Break out of the chrome's padding so the tabs and footer span edge to edge, and fill its
          height so the line items take the slack rather than the card growing to fit them. */}
      <div className="flex h-full flex-1 flex-col">
        <div className="flex border-gray-100 border-b">
          <span className="-mb-px border-gray-900 border-b-2 px-3 py-2 font-semibold text-[10.5px] text-gray-900">
            {t('features:onboarding.components.cart_preview.my_cart')}
          </span>
          <span className="px-3 py-2 font-semibold text-[10.5px] text-gray-400">
            {t('features:onboarding.components.cart_preview.my_account')}
          </span>
        </div>
        <div className="flex flex-1 flex-col">
          <CartLine nameWidth="62%" priceWidth="34%" qty="×1" />
          <CartLine nameWidth="50%" priceWidth="40%" qty="×2" />
        </div>
        <div className="flex items-center justify-between bg-gray-50 px-3 py-1.5">
          {/* Subtotal — a strong label bar + the total, rather than text. */}
          <span className="flex items-center gap-1.5">
            <Bar tone="strong" className="h-2 w-10" />
            <Bar className="h-2 w-6" />
          </span>
          {/* Checkout button: shape only, label as a bar (matches the price-list/widget CTAs). */}
          <span className="flex items-center justify-center rounded-md bg-platform-primary px-3 py-1.5">
            <Bar tone="onPrimary" className="h-1 w-10" />
          </span>
        </div>
      </div>
    </GraphicFrame>
  );
}
